import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { showFadeCarregando, showAlerta } from '@common/common.action';
import { bindActionCreators } from 'redux';

import {
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';

import favoritosApi from './favoritosApi';
import IntlMessage from '../../helpers/intlMessage';

function Favoritos(props) {
  const usuario = props.usuario;
  const [label, setLabel] = useState('');
  const [lista, setLista] = useState([]);
  const [dropDownAberto, setDropDownAberto] = useState(false);
  const [favoritoDefault] = useState({});
  const [modalAberto, setModalAberto] = useState(false);
  const [nomeFavorito, setNomeFavorito] = useState('');

  useEffect(() => {
    getFavoritos(props.tipo, usuario.usuarioId);
  }, [props.tipo]);

  useEffect(() => {}, [favoritoDefault]);

  useEffect(() => {}, [props.itens]);

  const alterarNomeFavorito = (nomeFavorito) => {
    if (nomeFavorito.length > 25) return;
    else setNomeFavorito(nomeFavorito);
  };

  const setFavoritoDefaut = (favoritoId) => {
    props.showFadeCarregando(true);
    favoritosApi.SetFavoritoDefault(+favoritoId).then((resp) => {
      getFavoritos(props.tipo, usuario.usuarioId);
      props.showFadeCarregando(false);
    });
  };

  const salvarFavorito = async (nomeFavorito) => {
    props.showFadeCarregando(true);

    const favorito = {
      nome: nomeFavorito,
      items: props.itens,
    };

    favoritosApi
      .PostFavoritoRequisicaoProtocolo(props.tipo, favorito)
      .then(async (resp) => {
        await getFavoritos(props.tipo, usuario.usuarioId);

        setLabel(favorito.nome);
        setModalAberto(!modalAberto);
        props.showAlerta('sucesso', 'Favorito salvo com sucesso', 800);
        props.showFadeCarregando(false);
      })
      .catch((error) => {
        const message = `Houve um erro na Api ao tentar salvar o favorito: ${error}`;
        props.showAlerta('erro', message, 2000, message.length * 10 + 'px');
        props.setLabel('Favoritos');
        props.limparAnticorposSelecionados();
        props.showFadeCarregando(false);
      });
  };

  const deletarFavorito = (favoritoId) => {
    props.showFadeCarregando(true);

    favoritosApi
      .DeletarFavorito(+favoritoId)
      .then((resp) => {
        getFavoritos(props.tipo, usuario.usuarioId);
        props.limparAnticorposSelecionados();
        setLabel('Favoritos');
        setDropDownAberto(false);
        props.showAlerta('sucesso', 'Favorito removido com sucesso', 800);
        props.showFadeCarregando(false);
      })
      .catch((error) => {
        const message = `Houve um erro na Api ao tentar salvar o favorito: ${error}`;
        props.showAlerta('erro', message, 2000, message.length * 10 + 'px');
        props.showFadeCarregando(false);
      });
  };

  const getFavoritos = async (tipo, usuarioId) => {
    let resp = await favoritosApi.GetFavoritoRequisicaoByUsuarioId(
      tipo,
      usuarioId
    );

    setLista(resp);

    let favoritoDefault = resp.filter((favorito) => favorito.isDefault);

    if (
      favoritoDefault !== 'undefined' &&
      favoritoDefault !== null &&
      favoritoDefault.length != null &&
      favoritoDefault.length > 0
    ) {
      props.setFavoritos(favoritoDefault[0]);
      setLabel(favoritoDefault[0].label);
    }
  };

  return (
    <div className="favoritos">
      <Dropdown
        direction="down"
        isOpen={dropDownAberto}
        toggle={() => setDropDownAberto(!dropDownAberto)}
      >
        <DropdownToggle className="button" caret>
          {/* {label} */} <IntlMessage id="dashboards.examDetail.favorites" />
        </DropdownToggle>
        <DropdownMenu style={{ overflowY: 'scroll', overflowX: 'hidden' }}>
          <div
            style={{
              maxHeight: `${window.innerHeight - 200}px`,
            }}
          >
            {lista.map((favorito, i) => {
              return (
                <div style={{ position: 'relative' }} key={i}>
                  <DropdownItem
                    style={{ marginRight: '15px' }}
                    onClick={() => {
                      props.setFavoritos(favorito);
                      setLabel(favorito.label);
                    }}
                  >
                    {favorito.label}
                  </DropdownItem>

                  <div className="filtro-favoritos-botoes">
                    <i
                      className={
                        favorito.isDefault ? 'fas fa-star' : 'far fa-star'
                      }
                      onClick={() => {
                        setFavoritoDefaut(favorito.value);
                        props.setFavoritos(favorito);
                        setLabel(favorito.label);
                      }}
                    ></i>
                    <i
                      className="fas fa-trash-alt"
                      onClick={() => {
                        deletarFavorito(favorito.value);
                      }}
                    ></i>
                  </div>
                </div>
              );
            })}
          </div>
        </DropdownMenu>
      </Dropdown>
      <Button
        disabled={props.habilitarSalvarFavoritos}
        onClick={() => setModalAberto(!modalAberto)}
        className="btn-salvar-favorito"
      >
        <IntlMessage id = "dashboards.examDetail.saveFavorite"/>
      </Button>
      <div>
        <Modal isOpen={modalAberto} toggle={() => setModalAberto(!modalAberto)}>
          <ModalHeader toggle={() => setModalAberto(!modalAberto)}>
            <IntlMessage id = "dashboards.examDetail.saveFilter"/>
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label><IntlMessage id = "dashboards.examDetail.favoriteName"/></Label>
              <Input
                value={nomeFavorito}
                onChange={(event) => {
                  alterarNomeFavorito(event.currentTarget.value);
                }}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button
              onClick={() => setModalAberto(!modalAberto)}              
            >
              <IntlMessage id = "dashboards.examDetails.cancel"/>
            </Button>
            <Button
              disabled={nomeFavorito.length === 0}
              onClick={() => {
                salvarFavorito(nomeFavorito);
                setNomeFavorito('');
              }}              
            >
              <IntlMessage id = "dashboards.examDetails.saveChange"/>
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ showFadeCarregando, showAlerta }, dispatch);

const mapStateToProps = (state) => ({ usuario: state.usuario });

export default connect(mapStateToProps, mapDispatchToProps)(Favoritos);



// WEBPACK FOOTER //
// ./src/componentes/Favoritos/index.js